import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);

  const superAdminLinks = [
    { path: '/super/dashboard', label: 'Dashboard' },
    { path: '/super/commerce', label: 'Control Center' },
    { path: '/super/shops', label: 'Shops' },
    { path: '/super/agents', label: 'Agents' },
    { path: '/super/plans', label: 'Plans' },
    { path: '/super/categories', label: 'Categories' },
    { path: '/super/ads', label: 'Ads' },
    { path: '/super/banner-ads', label: 'Banner Ads' }
  ];

  const shopAdminLinks = [
    { path: '/shop/dashboard', label: 'Dashboard' },
    { path: '/shop/profile', label: 'Profile' },
    { path: '/shop/plans', label: 'Plans' },
    { path: '/shop/ads', label: 'Ads' }
  ];

  const agentLinks = [
    { path: '/agent/dashboard', label: 'Dashboard' }
  ];

  let links = [];
  if (user?.role === 'superAdmin') {
    links = superAdminLinks;
  } else if (user?.role === 'agent') {
    links = agentLinks;
  } else {
    links = shopAdminLinks;
  }

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">Shop Offers Admin</div>
        <ul className="navbar-nav">
          {links.map(link => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={isActive(link.path) ? 'active' : ''}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
        <div className="navbar-user">
          <span>{user?.email}</span>
          <button className="logout-btn" onClick={logout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

